import {Box,MenuItem,Typography,FormControl,Select,createTheme,ThemeProvider} from '@mui/material';
 
const theme = createTheme({
  components: {
    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "#E6EDF1",
          },
          "&.Mui-selected:focus": {
            backgroundColor: "#E6EDF1",
          },
          "&.MuiMenuItem-root": {
            borderBottom: "1px solid #E6EDF1",
            fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
          },
          // '&.Mui-selected:hover': {
          // backgroundColor: 'black',
          // },
          // '&:hover': {
          // backgroundColor: 'lightblue',
          // },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          "&.MuiInputBase-root": {
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "24px",
            backgroundColor: "white",
            height: "40px",
            fontFamily: "Roboto medium, Helvetica, Arial, sans-serif"
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          "&.MuiPaper-root": {
            // overflow: "hidden",
          },
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          "&.MuiList-root": {
            paddingTop: 0,
            maxHeight: '30vh', // Set the desired height for the list
            overflowY: 'auto', // Enable vertical scrolling for the list,
          },
        },
      },
    },
    MuiListSubheader: {
      styleOverrides: {
        root: {
          "&.MuiListSubheader-root": {
            height: "32px",
            paddingLeft: 0,
            paddingRight: 0,
            borderColor: "#E6EDF1",
          },
          "&.MuiListSubheader-root:focus": {
            borderColor: "#E6EDF1",
          },
        },
      },
    },
  },
});
 
const PageDropdownReduxCopy = ({ tag, list, value, setValue, width, font = "14px", isColorCoded = false, alignContent='center'}) =>{
  // Color Codes map
  let colorCodes = {};
  if (colorCodes) {
    colorCodes["Pending"] = "#FFC700";
    colorCodes["Initial Review"] = "#7E79DD";
    colorCodes["Final Review"] = "#00A6CA";
    colorCodes["Rejected"] = "#EB0000";
    colorCodes["Accepted"] = "#008A00";
  }
  // set width if not given as prop
  if (width == null) {
    width = "12rem";
  }
  // set font size if given as prop, else use default
  let style = {};
  if (font != null) {
    style["fontSize"] = font;
  }
  // event handler to set value on dropdown change
  const onDropdownChange = (e) => {
    setValue(e.target.value);
  };
  // function to get the color coded dropdown li
  const getColorCodedDiv = (val) => {
    return (
      <div className="d-flex justify-content-start align-items-center gap-3">
        {colorCodes[val] && (
          <Box
            sx={{
              width: 12,
              height: 12,
              bgcolor: colorCodes[val],
              borderRadius: 100,
            }}
          />
        )}
        <div>{val}</div>
      </div>
    );
  };

  // Return searched results
  // const filteredList = useMemo(
  //   () =>
  //     list.filter(
  //       (option) => option.toLowerCase().indexOf(searchText.toLowerCase()) > -1
  //     ),
  //   [searchText, list]
  // );
  // const displayedList = isSearchable ? filteredList : list;
  const displayedList = list;
  

  let contentCss = "d-flex justify-content-center width-fit-content align-items-center gap-3"
  if ( alignContent === 'center') {
    contentCss = "d-flex justify-content-center width-fit-content align-items-center gap-3"
  }
  else if (alignContent === 'left') {
    contentCss = "d-flex justify-content-left width-fit-content align-items-left gap-3"
  }
  else if (alignContent === 'right'){
    contentCss = "d-flex justify-content-right width-fit-content align-items-right gap-3"
  }

  return (
    <div className={contentCss}>
      {/* material ui dropdown component */}
      <Typography fontSize={font} className="align-self-center lh-24">
        {tag}
      </Typography>
      <ThemeProvider theme={theme}>
        <FormControl
          className={"text-start"}
          fullWidth
          size="small"
          sx={{ minWidth: width, maxWidth: width }}
        >
          <Select
            className="lh-24"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            MenuProps={{
              // autoFocus: !isSearchable,
              style: {
                maxWidth: width,
              },
            }}
            value={value}
            style={style}
            onChange={(e) => onDropdownChange(e)}
            // onClose={() => setSearchText("")}
            // renderValue={() => value}
          >
            {/* {isSearchable && (
              <ListSubheader sx={{ marginBottom: "8px" }}>
                <TextField
                  fontSize={font}
                  size="small"
                  autoFocus
                  placeholder={"Search " + tag.toLowerCase()}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon
                          sx={{
                            width: "16px",
                            height: "16px",
                            color: "#54585A",
                          }}
                        />
                      </InputAdornment>
                    ),
                  }}
                  // onChange={(e) => setSearchText(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key !== "Escape") {
                      // Prevents autoselecting item while typing (default Select behaviour)
                      e.stopPropagation();
                    }
                  }}
                />
              </ListSubheader>
            )} */}
            {displayedList?.map((el) => (
              <MenuItem
                sx={{ height: "40px" }}
                className="lh-24"
                style={style}
                key={el}
                id={el}
                value={el}
              >
                {isColorCoded ? getColorCodedDiv(el) : el}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </ThemeProvider>
    </div>
  );
}
 
export default PageDropdownReduxCopy;